var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-modal',{attrs:{"title":_vm.title,"show-modal-content":_vm.showSignUpModal},on:{"close":_vm.resetStates}},[_c('div',{attrs:{"slot":"modal-content"},slot:"modal-content"},[(_vm.beforeSendMail)?_c('sign-up-modal-form'):_c('sign-up-modal-sent-mail')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }